import { FORTA_BLUE, FORTA_WHITE } from '../../../utils/colors';

export const PROVIDER_STATUS_CHIP_SX = {
  fontSize: '13px',
  fontWeight: '700',
  lineHeight: '18px',
} as const;

export const BASIC_INFO_ROW_SX = {
  backgroundColor: FORTA_WHITE,
  borderRadius: '10px',
  mt: 1,
} as const;

export const CLINICAL_STATUS_SELECT_SX = {
  flexGrow: 1,
  width: '100%',
  boxShadow: 'none',
  borderRadius: '8px',
  mr: 1,
} as const;

export const ASSIGNED_CLIENTS_HEADER_SX = {
  mb: 2,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
} as const;

export const ASSIGNED_CLIENTS_SEARCH_SX = {
  borderRadius: '8px',
  mr: 3.5,
  backgroundColor: FORTA_WHITE,
} as const;

export const ASSIGNED_CLIENTS_ROW_SX = {
  display: 'flex',
  p: 1.5,
  backgroundColor: FORTA_WHITE,
  mb: 2,
  borderRadius: '10px',
  direction: 'row',
  alignItems: 'center',
  fontSize: 16,
} as const;

export const PAYOR_CREDENTIALS_HEADER_SX = {
  mb: 2,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
} as const;

export const PAYOR_CREDENTIALS_ADD_BUTTON_SX = {
  width: 240,
  height: 45,
  borderRadius: '16px',
} as const;

export const PAYOR_CREDENTIALS_SEARCH_SX = {
  borderRadius: '8px',
  mr: 3.5,
  backgroundColor: FORTA_WHITE,
} as const;

export const PAYOR_CREDENTIALS_EMPTY_STATE_SX = {
  display: 'flex',
  justifyContent: 'center',
  width: '100%',
  m: 2,
} as const;

export const RELATIONSHIP_MANAGER_SELECT_CONTAINER_SX = {
  display: 'flex',
  alignItems: 'center',
  gap: 1,
} as const;

export const RELATIONSHIP_MANAGER_TITLE_SX = {
  textAlign: 'left',
  fontWeight: 'bold',
  color: FORTA_BLUE.primary,
  mb: 2,
} as const;

export const PROMOTE_DIALOG_SX = {
  '& .MuiModal-backdrop': {
    backdropFilter: 'blur(2px)',
    backgroundColor: 'rgba(255, 255, 255, 0.4)',
  },
} as const;

export const PROMOTE_DIALOG_CONTENT_SX = {
  py: 4,
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
} as const;

export const PROMOTE_ROLE_AUTOCOMPLETE_SX = {
  width: '100%',
  '& .MuiOutlinedInput-input': {
    minHeight: '40px',
  },
  boxShadow: 'none',
  mb: 2,
} as const;

export const PROVIDER_SSN_NO_HELPER_INPUT_SX = {
  '& > .MuiBox-root:last-child': {
    display: 'none',
  },
} as const;
